import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { authentication } from "@microsoft/teams-js";
import "./signInPage.scss";
import i18n from "../../i18n";
import { Button, Text } from "@fluentui/react-components"

const SignInPage: React.FunctionComponent<RouteComponentProps> = props => {
  const { t } = useTranslation();
  const errorMessage = t("SignInPromptMessage");

  function onSignIn() {
    const authParams: authentication.AuthenticatePopUpParameters = {
      url: window.location.origin + "/signin-simple-start"
    }
    authentication.authenticate(authParams).then(() => {
      console.log("Login succeeded!");
      window.location.href = "/messages";
    }).catch((reason: any) => {
      console.log("Login failed: " + reason);
      window.location.href = `/errorpage?locale=${i18n.language}`;
    })
  }

  return (
    <div className="sign-in-content-container">
      <Text size={400}>{errorMessage}</Text>
      <div className="space"></div>
      <Button appearance="primary" className="sign-in-button" onClick={onSignIn} >{t("SignIn")}</Button>
    </div>
  );
};

export default SignInPage;
